import template from './sw-cms-block-image-text-row.html.twig';
import './sw-cms-block-image-text-row.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
